import { customElement } from "lit/decorators.js";
import { Subheading } from "@/components/subheading";

@customElement("eko-modal-title")
class ModalTitle extends Subheading {
  constructor() {
    super();

    this.size = "lg";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-modal-title": ModalTitle;
  }
}

export default ModalTitle;
